import { render } from "./FixedPriceMarginWarning.vue?vue&type=template&id=41cf8271&scoped=true"
import script from "./FixedPriceMarginWarning.vue?vue&type=script&lang=js"
export * from "./FixedPriceMarginWarning.vue?vue&type=script&lang=js"

import "./FixedPriceMarginWarning.vue?vue&type=style&index=0&id=41cf8271&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41cf8271"]])

export default __exports__